var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"default-form\"\u003E\u003Cdiv class=\"form-header row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch4\u003ELOADING...\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"form-container form-body\"\u003E\u003Ci class=\"spinner\"\u003E\u003C\u002Fi\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/states/endSubscription/component/endSubscriptionInitial.jade
// module id = 916
// module chunks = 1